import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import heroVideo from "../assets/hero-bg.mp4";

const Hero = () => {
  return (
    <section
      id="hero"
      className="relative h-screen flex flex-col justify-center items-center text-center overflow-hidden"
      aria-label="Hero section showcasing Kwame O. Sarfo"
    >
      {/* Background Video */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src={heroVideo}
        autoPlay
        loop
        muted
        playsInline
        aria-label="Hero video background showcasing the ventures of Kwame O. Sarfo"
        preload="auto"
        poster="../assets/herobanner.jpg"  
      ></video>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/90"></div>

      {/* Hero Content */}
      <motion.div
        className="relative z-10 text-white px-6"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2 }}
      >
        <h1 className="text-5xl md:text-7xl font-bold mb-4 font-playfair">
          <span className="text-yellow-400">Kwame O. Sarfo</span>
        </h1>

        <p className="text-lg md:text-2xl max-w-2xl mx-auto mb-8 text-gray-300 font-light">
          Entrepreneur • Investor • Visionary Leader
        </p>

        <p className="max-w-xl mx-auto text-gray-400 mb-10 leading-relaxed">
          Building innovative businesses and creating sustainable value across
          industries driven by integrity, strategy, and impact.
        </p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
        >
          <Link
            to="/ventures"
            className="bg-yellow-400 text-black font-semibold px-8 py-3 rounded-full shadow-lg hover:bg-yellow-300 transition-transform transform hover:scale-105"
            title="Explore the business ventures of Kwame O. Sarfo"
            aria-label="Explore Kwame O. Sarfo's ventures"
          >
            Explore Ventures
          </Link>
        </motion.div>
      </motion.div>

      {/* Scroll Indicator */}
      <motion.div
        className="absolute bottom-10 text-white text-sm flex flex-col items-center z-10"
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 1.5 }}
      >
        <span className="text-gray-300">Scroll Down</span>
        <span className="mt-2 text-yellow-400 text-lg">↓</span>
      </motion.div>
    </section>
  );
};

export default Hero;
